<div *ngIf="actionPlanItem" class="ir-content-flow has-plugin" #scroll>
  <div class="ir-plugin th-plugin th-help" *ngIf="actionPlanItem?.description && showHelp" id="{{ actionPlanItem.id }}">
    <div class="ir-plugin-content" #plugin>
      <p class="ir-plugin-instruction">
        <span innerHtml="{{ actionPlanItem?.description }}"></span>
      </p>
    </div>
  </div>
  <div class="ir-plugin th-plugin">
    <div class="ir-line ir-plugin-title">
      <div class="ir-line-content">
        <span>{{ actionPlanItem.point?.name }}</span>
      </div>
    </div>
    <div class="ir-plugin-content">
      <table class="ir-plugin-table">
        <tbody>
          <tr class="th-plugin-line--header">
            <td colspan="5">
              <span *ngIf="actionPlanItem.observation && !observationKey"
                >{{ 'plugins.observation.name' | translate }} :
                <strong innerHtml="{{ actionPlanItem.observation }}"></strong
              ></span>
              <span *ngIf="observationKey"
                >{{ 'plugins.observation.name' | translate }} :
                <strong innerHtml="{{ observationKey | translate }}"></strong
              ></span>
            </td>
          </tr>
          <tr>
            <td colspan="5">
              <span
                >{{ 'plugins.observation.section' | translate }} :
                <strong innerHtml="{{ actionPlanItem.section?.name }}"></strong
              ></span>
            </td>
          </tr>
          <tr>
            <td colspan="5">
              <span *ngIf="actionPlanItem.recommandation && !recommandationKey"
                >{{ 'plugins.observation.recommandation' | translate }} :
                <strong innerHtml="{{ actionPlanItem.recommandation }}"></strong
              ></span>
              <span *ngIf="recommandationKey"
                >{{ 'plugins.observation.recommandation' | translate }} :
                <strong innerHtml="{{ recommandationKey | translate }}"></strong
              ></span>
            </td>
          </tr>
          <ng-container *ngFor="let i of actionPlanItem.impacts | keyvalue">
            <tr class="th-plugin-line--content" *ngIf="i.value.enabled">
              <td>
                <span>
                  {{ 'plugins.observation.impact' | translate }} :
                  <strong class="important">{{
                    'plugins.observation.value.' + i.value.id + '.title' | translate
                  }}</strong></span
                >
              </td>
              <td class="th-plugin-line--value">
                <span *ngIf="i.value.text"
                  ><strong class="important">{{ i.value.text }}</strong>
                  {{ 'plugins.observation.value.' + i.value.id + '.boost' | translate }}</span
                >
              </td>
            </tr>
          </ng-container>

          <!--<tr *ngIf="actionPlanItem.machines && actionPlanItem.machines.length">
          <td colspan="5">
            <span>{{ 'plugins.observation.machines' | translate  }} :
            <strong class="important" innerHtml="{{ actionPlanItem.machines.join(', ')  }}"></strong></span>
          </td>
        </tr>-->
          <tr *ngIf="actionPlanItem.machines && actionPlanItem.machines.length">
            <td colspan="5">
              <span
                >{{ 'plugins.observation.machines' | translate }} :
                <strong class="important" *ngFor="let m of actionPlanItem.machines; let isLast = last"
                  >{{
                    m.CustomerEquipementId
                      ? m.Name + '(' + m.CustomerEquipementId + ')'
                      : m.Name
                      ? m.Name
                      : getMachineName(m)
                  }}{{ isLast ? '' : ',
                  ' }}</strong
                ></span
              >
            </td>
          </tr>
          <tr
            *ngIf="
              actionPlanItem.observationPlugin?.TimeToRepairs && actionPlanItem.observationPlugin?.TimeToRepairs.length
            "
          >
            <td colspan="5">
              <span>{{ 'plugins.time-to-repair.name' | translate }} :</span>
            </td>
          </tr>
          <tr *ngFor="let timeToRepair of actionPlanItem.observationPlugin?.TimeToRepairs">
            <td colspan="5">
              <span
                ><strong>{{ 'plugins.time-to-repair.repair-will-take' | translate }}</strong>
                <strong class="ir-ph1 important"
                  >{{ timeToRepair?.Hours | number: '2.0' }}:{{ timeToRepair?.Minutes | number: '2.0' }}
                </strong>
                <strong
                  >{{ 'plugins.time-to-repair.hours' | translate }}
                  {{ 'plugins.time-to-repair.by' | translate }}</strong
                >
                <strong class="ir-ph1 important">{{ timeToRepair?.Reparator | reparatorpipe }}</strong></span
              >
            </td>
          </tr>
          <tr *ngIf="actionPlanItem.observationPlugin?.Parts && actionPlanItem.observationPlugin?.Parts.length">
            <td colspan="5">
              <span>{{ 'plugins.parts.parts-management' | translate }} :</span>
            </td>
          </tr>
          <tr *ngFor="let part of actionPlanItem.observationPlugin?.Parts">
            <td colspan="5">
              <span
                ><strong>{{ part?.Id }}-{{ part?.Page }}-{{ part?.Position }}-{{ part?.PartsName }}</strong></span
              ><span *ngIf="part?.Quantity"
                ><strong class="important"> x {{ part?.Quantity }}</strong></span
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <action-plan-item-status [actionPlanItem]="actionPlanItem"></action-plan-item-status>
  <!--Plugins-->
  <div *ngFor="let p of actionPlanItem.plugins | orderBy: 'order' | searchBy: query" #p.id>
    <ir-plugin [plugin]="p" [inspection]="actionPlan" #plugin></ir-plugin>
  </div>
</div>
<div class="ir-position--b th-footer-plugins">
  <div class="ir-row"></div>
  <!--<div class="ir-row">
    <div class="ir-cell-tin3 ir-cell-sma3 ir-cell-mid3 ir-cell-lar3" [ngClass]="currentIndex === maxIndex ? 'disabled' : ''"
         (click)="gotoNextPlugin()">
      <div class="ir-btn ir-btn--big ir-btn--block th-btn-footerplugin">
        <i class="material-icons">arrow_downward</i>
      </div>
    </div>
    <div class="ir-cell-tin3 ir-cell-sma3 ir-cell-mid3 ir-cell-lar3" [ngClass]="currentIndex === 0 ? 'disabled' : ''" (click)="gotoPreviousPlugin()">
      <div class="ir-btn ir-btn--big ir-btn--block th-btn-footerplugin">
        <i class="material-icons">arrow_upward</i>
      </div>
    </div>
    <div class="ir-cell-tin3 ir-cell-sma3 ir-cell-mid3 ir-cell-lar3" [routerLink]="getEditNotesRoute()">
      <div class="ir-btn ir-btn--big ir-btn--block" [ngClass]="actionPlanItem.notes ? 'th-btn-normal' : ''">
        <span>{{ 'points.my-notes' | translate  }}</span><span *ngIf="actionPlanItem.notes">&nbsp; &#9679;</span>
      </div>
    </div>
    <div class="ir-cell-tin3 ir-cell-sma3 ir-cell-mid3 ir-cell-lar3">
      <button class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right" (click)="updateStatus()" *ngIf="!processing">
        <span *ngIf="actionPlanItem.status !== 200">{{ isDone() ? ('points.undone' | translate) : ('points.done' | translate)  }}</span>
        <span *ngIf="actionPlanItem.status === 200">{{ 'points.restore' | translate  }}</span>
      </button>
      <button class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right" type="submit" *ngIf="processing">
        <span>{{ 'common.processing' | translate  }}</span>
      </button>
    </div>
  </div>-->
</div>
